// Real client testimonials
export const TESTIMONIALS = {
  confidence: {
    quote:
      "I can't tell you how much easier this has been recently for me. So many times now where I am standing in my own puddle of CONFIDENCE explaining what I do.",
    attribution: "Private client",
  },
  moneyMindset: {
    quote:
      "Did some money mindset work during my sesh with J today, so naturally I sold something in my business like an hour later.",
    attribution: "Private client",
  },
  thirtyEightK: {
    quote: "$38K month so far... with 4 hours left to go.",
    attribution: "Private client",
  },
  fortyFourK: {
    quote: "44K for October. Highest month yet.",
    attribution: "Private client",
  },
  boldJump: {
    quote:
      "I've said YES to you more than once and that BOLD INTUITIVE JUMP has blown my world wide open in the best of ways.",
    attribution: "Private client",
  },
  powerfulStory: {
    quote:
      "It's a powerful story for your coaching too. 30 days ago, it was a dream. Now it's live and queen suites are already sold out.",
    attribution: "Private client",
  },
  capacity: {
    quote:
      "My capacity since we've started working together has expanded exponentially.",
    attribution: "Private client",
  },
};
